import React, { useEffect, useState, Fragment, forwardRef } from "react";
import { Row, Col } from 'antd';
import QuizCard from 'ReusableComponents/QuizCard/QuizCard';
import { fetchQuizLocal, getFirstQuizQuestionName, } from 'quizdb';
import { quizNameToDeploymentUrl } from 'lib';

export default function QuizMenu(props) {
  const { form, inputData, questionsKey, language, } = props,
    { required, questions, options: quizzes, id, defaultValue } = inputData,
    { getFieldDecorator } = form;
  const [activeQuizIndex, setActiveQuizIndex] = useState(-1);

  const setActiveQuiz = (index) => {
    setActiveQuizIndex(index);
  }

  useEffect(() => {
    let isMounted = true;

    if (activeQuizIndex > -1) {
        const quizName = quizzes[activeQuizIndex].quizName;
        const quiz = fetchQuizLocal(quizName);
        const questionName = getFirstQuizQuestionName(quiz)
        const detail = {
          quizName,
          questionName,
        }
        const event = new CustomEvent('NameChange', {detail});
        document.dispatchEvent(event);
    }

    return () => { isMounted = false }
  }, [activeQuizIndex]);

  return (
    <Fragment>
      <Row type="flex" justify="center" align="middle" gutter={[8,8]}>
        {quizzes.map((quiz, index) => {
          return (
            <Fragment key={index}>
              <Col>
                <QuizCard quizName={quiz.quizName}
                          description={quiz.description}
                          onClick={()=>setActiveQuiz(index)}
                          activeQuizIndex={activeQuizIndex}
                          thisQuizIndex={index}
                />
              </Col>
            </Fragment>
          )
        })}
      </Row>
    </Fragment>
  );
};
